import { withCompController } from '@wix/editor-elements-integrations';
import type {
  TextParticlesMapperProps,
  TextParticlesStateValues,
  TextParticlesControllerProps,
} from '../TextParticles.types';

export default withCompController<
  TextParticlesMapperProps,
  TextParticlesControllerProps,
  never,
  TextParticlesStateValues
>(({ stateValues, mapperProps }) => {
  const { currentUrlWithQueryParams } = stateValues;
  const urlParams = new URLSearchParams(currentUrlWithQueryParams);
  // Checking if our component is rendered in saved assets panel
  // This is a workaround to make our component render text in the asset
  // Studio does not provide a proper api for this
  // https://wix.slack.com/archives/CJ4N4DYT1/p1753702261124379
  const isPresetPreview = urlParams.get('dsOrigin') === 'preset_preview';

  return {
    ...mapperProps,
    reducedMotion: stateValues.reducedMotion,
    isPresetPreview,
  };
});
